/**
 * QRCodeModal - Modal to display QR code for public tournament viewing
 */
import React, { useState, useCallback } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import firebaseSyncService from '../../services/firebaseSync';
import './QRCodeModal.css';

const QRCodeModal = ({ isOpen, onClose }) => {
  const [copied, setCopied] = useState(false);

  const tournamentId = firebaseSyncService.currentTournamentId;
  const viewUrl = tournamentId
    ? `${window.location.origin}/view-tournament-americano.html?id=${tournamentId}`
    : null;

  const handleCopy = useCallback(async () => {
    if (!viewUrl) return;

    try {
      await navigator.clipboard.writeText(viewUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback
      const input = document.querySelector('.qrcode-url-input');
      if (input) {
        input.select();
        document.execCommand('copy');
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    }
  }, [viewUrl]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="qrcode-modal-overlay" onClick={handleOverlayClick}>
      <div className="qrcode-modal">
        <div className="qrcode-modal-header">
          <h5>
            <i className="bi bi-qr-code"></i>
            QR Code - Consultation du tournoi
          </h5>
          <button className="qrcode-modal-close" onClick={onClose} aria-label="Fermer">
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        {viewUrl ? (
          <>
            <div className="qrcode-modal-body">
              <p>Scannez ce QR code pour consulter le classement et les résultats en temps réel</p>

              <div className="qrcode-container">
                <QRCodeSVG
                  value={viewUrl}
                  size={256}
                  level="H"
                  bgColor="#ffffff"
                  fgColor="#000000"
                />
              </div>

              <div className="qrcode-url-group">
                <input
                  type="text"
                  className="qrcode-url-input"
                  value={viewUrl}
                  readOnly
                />
                <button
                  className={`qrcode-copy-btn ${copied ? 'copied' : ''}`}
                  onClick={handleCopy}
                >
                  <i className={`bi ${copied ? 'bi-check-lg' : 'bi-clipboard'}`}></i>
                  {copied ? 'Copié !' : 'Copier'}
                </button>
              </div>

              <a
                href={viewUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="qrcode-open-link"
              >
                <i className="bi bi-box-arrow-up-right"></i>
                Ouvrir la page
              </a>
            </div>

            <div className="qrcode-modal-footer">
              <button onClick={onClose}>
                <i className="bi bi-x-lg me-2"></i>Fermer
              </button>
            </div>
          </>
        ) : (
          <div className="qrcode-no-tournament">
            <i className="bi bi-exclamation-triangle-fill d-block"></i>
            <h5>Tournoi non sauvegardé</h5>
            <p>
              Veuillez d'abord sauvegarder votre tournoi pour générer un QR Code.
            </p>
            <div className="qrcode-modal-footer">
              <button onClick={onClose}>
                <i className="bi bi-x-lg me-2"></i>Fermer
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QRCodeModal;
